// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"r9-z"};